import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Backdrop,
  CircularProgress,
  Typography,
  Button,
  Tooltip,
  Box,
} from '@mui/material';
import HttpService from '../../hooks/Https-services';
import { API_ROUTES, hasRole, ROLE_IDS } from '../../utils/constant';
import { toast } from 'react-toastify';
import useCommonDetails from '../../hooks/useCommonDetails';
import RefreshIcon from '@mui/icons-material/Refresh';
export default function ModeratorGameCountTable() {
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  const currentUserInfo = useCommonDetails();
  const getTableData = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await HttpService.get(API_ROUTES.activeModeratorList);
      const apiData = response.data.data;
      setTableData(apiData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getTableData();
  }, [getTableData]);

  const shuffleGameForModerator = async () => {
    try {
      setLoading(true);
      const response = await HttpService.post(API_ROUTES.shuffleGame);
      toast.success('Shuffle Game Successfully');
      getTableData();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error fetching teams list:', error);
    }
  };
  function ModeratorGameCountTable({ data }: { data: any[] }) {
    return (
      <>
        {' '}
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {' '}
          <Typography variant="h6" fontWeight={600}>
            Moderator Game Count
          </Typography>
          {hasRole(currentUserInfo.roleId, [
            ROLE_IDS.ADMIN,
            ROLE_IDS.SUPER_ADMIN,
          ]) &&
            currentUserInfo.teamId === 3 && (
              <Box>
                <Tooltip title="Shuffle Game For Moderator">
                  <span>
                    <Button
                      onClick={() => shuffleGameForModerator()}
                      variant="contained"
                      color="info"
                      disabled={loading}
                      sx={{ minWidth: 48, padding: 1 }} // Ensure proper spacing
                    >
                      {loading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <RefreshIcon />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </Box>
            )}
        </Box>
        <TableContainer component={Paper} sx={{ maxHeight: '250px', mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>In Progress</TableCell>
                <TableCell>In QC</TableCell>
                <TableCell>Total Games</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.createdCount}</TableCell>
                    <TableCell>{row.inProgressCount}</TableCell>
                    <TableCell>{row.inQcCount}</TableCell>
                    <TableCell>{row.totalGames}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>
                    {' '}
                    {/* Adjust colSpan based on the number of columns */}
                    <Typography>No Data</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </TableContainer>
      </>
    );
  }

  return (
    <>
      <ModeratorGameCountTable data={tableData} />
    </>
  );
}
